import React from 'react';
import { Label } from 'react-aria-components';
import { Popover } from '../popover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import './index.scss';

type InputLabelProps = {
  children: string;
  type?: 'label' | 'description';
  asterisk?: boolean;
  description?: string;
  tipTitle?: string;
  tipDescription?: string;
};

export const InputLabel = ({ children, type, asterisk, description, tipTitle, tipDescription }: InputLabelProps) => {
  const { t } = useTranslation();

  return (
    <div className="rac-input-label-wrapper">
      <Label data-type={type ?? 'label'}>{children}</Label>
      {asterisk && (
        <div aria-hidden className="rac-input-label-asterisk">
          *
        </div>
      )}
      {tipTitle && tipDescription && <Popover title={t(tipTitle)} descriptionOne={t(tipDescription)}></Popover>}
      {description && <FontAwesomeIcon icon={faCircleInfo} className="rac-input-label-icon" />}
    </div>
  );
};

export default InputLabel;
